/* CardList.tsx generated by @compiled/babel-plugin v3.0.1 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2mHwu8kG2W%7Bgap%3Avar(--ds-space-250%2C20px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3iDTPbgBM8%7Bdisplay%3Agrid%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2iEGP28wUV%7Bgrid-template-columns%3Aminmax(0%2C1fr)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=%40media%20(min-width%3A48rem)%7B._3E0AG27s7Z%7Bgrid-template-columns%3Arepeat(2%2Cminmax(0%2C1fr))%7D%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=%40media%20(min-width%3A64rem)%7B._4cQPhCbyVk%7Bgrid-template-columns%3Arepeat(3%2Cminmax(0%2C1fr))%7D%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=%40media%20(min-width%3A90rem)%7B._1YDlQuluOB%7Bgrid-template-columns%3Arepeat(4%2Cminmax(0%2C1fr))%7D%7D");
import React, { useId, useMemo, useState } from 'react';
import { useIntl } from 'react-intl';
import Button from '@atlaskit/button/default/button';
import { cx } from '@atlaskit/css';
import Heading from '@atlaskit/heading/heading';
import ChevronRightIcon from '@atlaskit/icon/core/chevron-right';
import ChevronUpIcon from '@atlaskit/icon/core/chevron-up';
import { Box, Inline, Stack } from '@atlaskit/primitives/compiled';
import type { CardListProps, GridColumns } from '../../types';
import { messages } from './messages';
const styles = {
  grid: "_2mHwu8kG2W _3iDTPbgBM8 _2iEGP28wUV",
  columns2: "_3E0AG27s7Z",
  columns3: "_3E0AG27s7Z _4cQPhCbyVk",
  columns4: "_3E0AG27s7Z _4cQPhCbyVk _1YDlQuluOB"
};
const columnStyles = ({
  2: styles.columns2,
  3: styles.columns3,
  4: styles.columns4
} satisfies Record<GridColumns, unknown>);
export const CardList = ({
  columns = 3,
  children,
  emptyState,
  heading,
  isCollapsible = false,
  testId
}: CardListProps): React.JSX.Element => {
  const {
    formatMessage
  } = useIntl();
  const [isExpanded, setIsExpanded] = useState(false);
  const cardListId = useId();
  const cards = useMemo(() => React.Children.toArray(children), [children]);
  const canCollapse = isCollapsible && cards.length > columns;
  const visibleCards = useMemo(() => canCollapse && !isExpanded ? cards.slice(0, columns) : cards, [cards, canCollapse, columns, isExpanded]);
  return <Stack space="space.200">
			{heading || canCollapse ? <Inline alignBlock="center" spread="space-between">
					{heading ? <Heading size="small" as="h2">
							{heading}
						</Heading> : null}
					{canCollapse ? <Button appearance="subtle" spacing="compact" aria-controls={cardListId} aria-expanded={isExpanded} iconAfter={isExpanded ? ChevronUpIcon : ChevronRightIcon} onClick={() => setIsExpanded(currentValue => !currentValue)} testId={testId ? `${testId}--toggle` : undefined}>
							{formatMessage(isExpanded ? messages.showLess : messages.viewAll)}
						</Button> : null}
				</Inline> : null}
			{cards.length === 0 && emptyState !== undefined ? emptyState : <Box id={cardListId} xcss={cx(styles.grid, columnStyles[columns])} testId={testId}>
					{visibleCards}
				</Box>}
		</Stack>;
};